import { z } from 'zod';
import { DashboardRole } from './roles.js';

export const Member = z.object({
  email_id: z.string().email(),
  name: z.string().nullable().optional(),
  company: z.string().nullable().optional(),
  mobile: z.string().nullable().optional(),
  user_type: z.string().nullable().optional(),
  reseller_id: z.string().nullable().optional(),
  is_active: z.boolean().optional(),
  role: DashboardRole.optional(),
});
export type Member = z.infer<typeof Member>;

export const TeamResponse = z.object({
  workspace_id: z.string(),
  members: z.array(
    Member.extend({
      client_access_status: z.string().nullable().optional(),
      active_sessions: z.number().int().nonnegative().default(0),
      last_seen: z.union([z.string(), z.number()]).nullable().optional(),
    }),
  ),
});
export type TeamResponse = z.infer<typeof TeamResponse>;
